import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnChanges {
  dropdownOpen = false;
  @Input() placeholder: string = '';
  @Input() options: { value: string | number, label: string, icon?: string }[] = [];
  @Input() isMultiSelect = false;
  @Input() defaultValue: { value: string | number, label: string, icon?: string } | string | { value: string | number, label: string, icon?: string }[] = '';
  @Output() emitValue = new EventEmitter<string | number | { value: string | number, label: string, icon?: string }[]>();

  selectedOptions: { value: string | number, label: string, icon?: string }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultValue']) {
      this.handleDefault();
    }
  }

  toggleDropdown(): void {
    if (this.options.length > 0) {
      this.dropdownOpen = !this.dropdownOpen;
    }
  }

  handleDefault(): void {
    if (this.defaultValue) {
      if (Array.isArray(this.defaultValue)) {
        this.selectedOptions = this.defaultValue;
      } else if (typeof this.defaultValue === 'object') {
        this.selectedOptions = [this.defaultValue];
      } else {
        const foundOption = this.options.find(option => option.value === this.defaultValue);
        this.selectedOptions = foundOption ? [foundOption] : [];
      }
      this.selectOption(this.selectedOptions[0], new Event('click'));
    } else {
      this.selectedOptions = [];
    }
  }

  selectOption(option: { value: string | number, label: string, icon?: string }, event: Event): void {
    event.stopPropagation();
    if (this.isMultiSelect) {
      this.toggleSelection(option);
      this.emitValue.emit(this.selectedOptions);
    } else {
      this.selectedOptions = [option];
      this.dropdownOpen = false;
      this.emitValue.emit(option.value);
    }
  }

  toggleSelection(option: { value: string | number, label: string }): void {
    const index = this.selectedOptions.findIndex(selected => selected.value === option.value);
    index > -1 ? this.selectedOptions.splice(index, 1) : this.selectedOptions.push(option);
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
  }

  isSelected(option: { value: string | number, label: string }): boolean {
    return this.selectedOptions.some(selected => selected.value === option.value);
  }

  getSelectedOptionsText(): string {
    return this.selectedOptions.length
      ? this.selectedOptions.map(option => option.label).join(', ')
      : 'Select an option';
  }
}
